import { Link } from 'react-router-dom';
import { useState, useMemo, useEffect } from 'react';
import { withReact } from "slate-react";
import { createEditor, Text } from "slate";
import { updateDoc, doc, deleteDoc, Timestamp, getDoc } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import { MdModeEdit, MdUpdate } from "react-icons/md";
import Swal from 'sweetalert2';
import RichTextEditor from "../components/RichTextEditor";
import { toDateOnly, backToTimestamp } from "../components/EditViolation";
import { Leaf, Element } from "../components/RichTextEditor";

const getBlankRichText = () => [{ type: 'paragraph', children: [{ text: '' }] }];

export default function ViolationCard({currentItems, hasText, setViolations, editViolation, setEditViolation}) {
    const [updateViolation, setUpdateViolation] = useState(false);
    const [userRole, setUserRole] = useState(null);

    const userAuth = auth.currentUser;

    useEffect(() => {
        if (!userAuth) return;
    
        const getUserRole = async () => {
            const userRef = doc(db, "users", userAuth.uid);
            const userSnap = await getDoc(userRef);
    
            if (userSnap.exists()) {
                setUserRole(userSnap.data().role);
            }
        };
    
        getUserRole();
    }, [userAuth]);

    const handleUpdate = async (e) => {
        e.preventDefault();

        Swal.fire({
            title: "Are you sure?",
            text: "Changing the Effective Start Date will create a new version of this violation. The current version will have an end date set to the day before the new version's start date.",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Save",
            confirmButtonColor: "#3085d6",
            denyButtonText: `Don't save`
        }).then(async(result) => {

            if (result.isConfirmed) {
                if (!updateViolation?.effectiveStartDate || updateViolation.effectiveStartDate < new Timestamp(946684800, 0) || 
                    !updateViolation?.effectiveStartDate || updateViolation.effectiveStartDate > new Timestamp(4102444800, 0)) {
                    Swal.fire({
                        icon: "error",
                        title: "Invalid Date",
                        text: "Effective Start Date cannot be before January 1, 2000 or after December 31, 2099.",
                        confirmButtonColor: "#3085d6",
                    });
                    return;
                }

                if (updateViolation.fine < 0) {
                    updateViolation.fine = 0;
                }

                const violationRef = doc(db, "violations", updateViolation.id);
                const updateViolations = {
                    fine: updateViolation.fine,
                    effectiveStartDate: updateViolation.effectiveStartDate,
                    modified_date: Timestamp.now(),
                    modified_user: userAuth.email,
                };

                updateViolations.reduce = updateViolation.reduce != null ? Number(updateViolation.reduce) : null;
                updateViolations.acceptableProof = updateViolation.reduce != null ? value : getBlankRichText();
                updateViolations.additionalInfo = value2;

                await updateDoc(violationRef, updateViolations)
                
                setViolations(prevViolations =>
                    prevViolations.map(violation =>
                        violation.id === updateViolation.id ? { ...violation, ...updateViolations } : violation
                    )
                );
                Swal.fire({
                    toast: true,
                    position: 'bottom', 
                    icon: 'success',
                    title: 'New Violation Created!',
                    showConfirmButton: false,
                    timer: 3000,
                    customClass: {
                      popup: 'swal-bottom-center'
                    }
                });
                setUpdateViolation(null); 
            } 
            
            else if (result.isDenied) {
                Swal.fire("Changes are not saved", "", "info");
            }
        });
    };

    const handleEdit = async (e) => {
        e.preventDefault();

        Swal.fire({
            title: "Do you want to save the changes?",
            html: `This will only update the current violation version for the Effective Start Date: <strong>${formattedDate}</strong>. To edit start date choose the update icon.`,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Save",
            confirmButtonColor: "#3085d6",
            denyButtonText: `Don't save`
        }).then(async(result) => {

            if (result.isConfirmed) {
                if (editViolation.fine < 0) {
                    editViolation.fine = 0;
                }

                const violationRef = doc(db, "violations", editViolation.id);
                const updateViolations = {
                    fine: editViolation.fine,
                    effectiveStartDate: editViolation.effectiveStartDate,
                    modified_date: Timestamp.now(),
                    modified_user: userAuth.email,
                };

                updateViolations.reduce = editViolation.reduce != null ? Number(editViolation.reduce) : null;
                updateViolations.acceptableProof = editViolation.reduce != null ? value : getBlankRichText();
                updateViolations.additionalInfo = value2;

                await updateDoc(violationRef, updateViolations)
                
                setViolations(prevViolations =>
                    prevViolations.map(violation =>
                        violation.id === editViolation.id ? { ...violation, ...updateViolations } : violation
                    )
                );
                Swal.fire({
                    toast: true,
                    position: 'bottom',
                    icon: 'success',
                    title: 'Edit Saved!',
                    showConfirmButton: false,
                    timer: 3000,
                    customClass: {
                      popup: 'swal-bottom-center'
                    }
                  });
                setEditViolation(null); 
            } 
            
            else if (result.isDenied) {
                Swal.fire("Changes are not saved", "", "info");
            }
        });
    }
        
    const handleDelete = async (e) => {
        e.preventDefault();
        const violationRef = doc(db, "violations", editViolation.id);
        Swal.fire({
            title: "Are you sure?",
            html: "You <strong>will not</strong> be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
            }).then(async (result) => {
            if (result.isConfirmed) {
                await deleteDoc(violationRef);
                setViolations(prevViolations => prevViolations.filter(violation => violation.id !== editViolation.id));
                Swal.fire({
                    toast: true,
                    position: 'bottom', 
                    icon: 'success',
                    title: 'Violation Deleted!',
                    showConfirmButton: false,
                    timer: 3000,
                    customClass: {
                      popup: 'swal-bottom-center'
                    }
                });
            }
        });
    }

    const handleRemoveReduce = async (e) => {
        e.preventDefault();
        Swal.fire({
            title: "Are you sure?",
            html: "This will delete the reduce amount and acceptable proof for this violation. Additional info will be kept.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setEditViolation({ ...editViolation, reduce: null, acceptableProof: getBlankRichText() });
                setValue(getBlankRichText());
                Swal.fire({
                    title: "Removed!",
                    text: "Reduce amount and acceptable proof have been removed. Save Edit to continue with changes.",
                    icon: "success",
                    confirmButtonColor: "#3085d6",
                });
            }
        });
    }

    const startEditViolation = (violation) => {
        setValue(violation.acceptableProof || getBlankRichText());
        setValue2(violation.additionalInfo || getBlankRichText());
        setEditViolation(violation);
    };

    const startUpdateViolation = (violation) => {
        setValue(violation.acceptableProof || getBlankRichText());
        setValue2(violation.additionalInfo || getBlankRichText());
        setUpdateViolation(violation);
    };

    useEffect(() => {
        if (!editViolation) {
            setValue(getBlankRichText());
            setValue2(getBlankRichText());
            return;
        }
      
        setValue(editViolation.acceptableProof || getBlankRichText());
        setValue2(editViolation.additionalInfo || getBlankRichText());

    }, [editViolation]);

    useEffect(() => {
        if (!updateViolation) {
            setValue(getBlankRichText());
            setValue2(getBlankRichText());
            return;
        }

        setValue(updateViolation.acceptableProof || getBlankRichText());
        setValue2(updateViolation.additionalInfo || getBlankRichText());
    }, [updateViolation]);

    const renderRichText = (nodes, inLink = false) => {
        if (!Array.isArray(nodes)) return null;
    
        return nodes.map((node, index) => {
            if (Text.isText(node)) {
                return <Leaf key={index} leaf={node} attributes={{}}>{node.text}</Leaf>;
            }
    
            const isLink = node.type === 'link' || node.type === 'email';
    
            // If already in a link, don't let <Element> render another <a>
            if (inLink && isLink) {
                return <span key={index}>{renderRichText(node.children, true)}</span>;
            }
    
            return (
                <Element key={index} element={node} attributes={{}}>
                    {!isLink && "- "}
                    {renderRichText(node.children, inLink || isLink)}
                </Element>
            );
        });
    };

    const [value, setValue] = useState(getBlankRichText);
    const [value2, setValue2] = useState(getBlankRichText); 

    // Only rerender when changed
    const formattedDate = useMemo(() => {
        if (!editViolation?.effectiveStartDate) return "";
        return toDateOnly(editViolation.effectiveStartDate);
        }, [editViolation?.effectiveStartDate]);

    const formattedDate2 = useMemo(() => {
        if (!updateViolation?.effectiveStartDate) return "";
        return toDateOnly(updateViolation.effectiveStartDate);
        }, [updateViolation?.effectiveStartDate]);
    
    const withInlines = editor => {
        const { isInline } = editor;
        editor.isInline = element => (element.type === 'link' ? true : isInline(element));
        return editor;
    };

    const editor = useMemo(() => withInlines(withReact(createEditor())), []);
    const editor2 = useMemo(() => withInlines(withReact(createEditor())), []);

    return (
        <>
        {currentItems.map((violation) => (
            <div key={violation.id}>
                {editViolation?.id === violation.id ? (
                 
                    <div className="violation-card-admin-edit">
                        <div className="violation-card-admin-layout">
                            <form onSubmit={handleEdit} className="violation-edit-form" name="editViolationForm">
                                <label style={{marginTop: "10px", margin: "0 auto", marginBottom: "10px"}}><strong>Quick Edit: <span style={{color: "#006C94"}}>{violation.arsCode}</span></strong></label>
                                <p style={{color: "red", fontSize: "12px", margin: "0 auto", marginTop: "-12px", marginBottom: "2px"}}><strong>Note: </strong>This will only update the 
                                    current violation for the Effective Start Date: <strong>{violation.effectiveStartDate.toDate().toLocaleDateString()}</strong></p>
                                <div className="form-row ">
                                    <label htmlFor="arsCode">ARS Code:</label>
                                    <input disabled id="arsCode" className="form-input-bold" type="text" title="ARS Code" value={editViolation.arsCode} placeholder="ARS-Code"
                                        style={{cursor: "not-allowed", backgroundColor: "#ececec", color: "#000000",}}/>
                                </div>
            
                                <div className="form-row">
                                    <label htmlFor="fine">Fine:</label>
                                    <input id="fine" type="number" title="Fine" value={editViolation.fine} placeholder="Fine" min="0" onChange={(e) =>
                                        setEditViolation({ ...editViolation, fine: parseFloat(e.target.value) })} onWheel={(e) => e.target.blur()} onFocus={(e) => e.target.select()} required/>
                                </div>
            
                                <div className="form-row">
                                    <label htmlFor="effectiveStartDate">Effective Start Date:</label>
                                    <input disabled type="date" title="Effective Start Date" value={formattedDate} style={{cursor: "not-allowed", backgroundColor: "#ececec", color: "#000000",}}/>
                                </div>
                                    <div className="rich-text-editor-edit-violation">
                                    {editViolation.reduce != null ? (
                                        <div>
                                            <div className="form-row">
                                                <label htmlFor="reduce">Reduce To Amount: </label>
                                                <input id="reduce" title="Reduce To Amount" type="number" style={{ marginBottom: "8px" }} value={editViolation.reduce} required min="0"
                                                    onWheel={(e) => e.target.blur()} onFocus={(e) => e.target.select()} onChange={(e) => {
                                                    setEditViolation({ ...editViolation, reduce: (Number(e.target.value)) })}}/>
                                            </div>
                                            <div className="reduceFineNo">
                                                <label htmlFor="removeReduce" title="Remove Reduce Amount" className="remove-reduce-label" style={{cursor: "pointer"}}><span style={{textDecoration: "underline"}}>Remove Reduce Amount:</span> <span style={{fontWeight: "bold"}}>(This will <span style={{ color: "red"}}
                                                    >delete</span> the acceptable proof)</span>
                                                    <input type="checkbox" id="removeReduce" onChange={(e) => { handleRemoveReduce(e); }} />
                                                </label>
                                            </div>    
                                        </div>
                                    ) : (
                                    <div className="reduceFineYes">
                                        <label id="needReduceLabel" title="Reduce fine amount?" style={{cursor: "pointer", textDecoration: "underline"}}>Need to reduce fine amount?
                                        <input type="checkbox" id="needReduce" checked={false} onChange={(e) => {if (e.target.checked) {
                                            setEditViolation({ ...editViolation, reduce: 0})}}}/>
                                        </label>
                                    </div>
                                )}
                                        <div style={{width: "100%", marginTop: "10px", marginBottom: "10px"}}>
                                            <RichTextEditor key={`${editViolation.id}-${editViolation.reduce != null ? "reduce" : "info"}`} editor={editor} editor2={editor2} value={value} 
                                                value2={value2} onChange={(value) => setValue(value)} onChange2={(value2) => setValue2(value2)} headerText={false} showFirst={editViolation.reduce != null}/>
                                        </div>    
                                    </div>
                                    <div className="controls-container">
                                        <Link to={`/dashboard/history/${violation.originalDocID}`} state={{ violation }} style={{fontSize: "14px"}} className="view-history-link" title="Show History">Show History</Link>
                                        <div className="buttons-container">
                                            <button className="save-edit-button" title="Save Edit" type="submit">Save Edit</button>
                                            {userRole === "admin" && (<button className="delete-violation-button" title="Delete Entire Violation" type="button" 
                                                onClick={handleDelete}>Delete Violation</button>)}
                                            <button className="cancel-edit-button" title="Cancel Edit" type="button" onClick={() => setEditViolation(null)}>Cancel</button>
                                        </div>
                                    </div>
                                    {/*<div style={{ flexBasis: '100%', height: 0 }}></div>*/}
                                    
                            </form>
                        </div>
                    </div>
                
                ) : updateViolation?.id === violation.id ? (
                    
                    <div className="violation-card-admin-edit">
                        <div className="violation-card-admin-layout">
                            <form onSubmit={handleUpdate} className="violation-edit-form" name="editViolationForm">
                                <label style={{marginTop: "10px", margin: "0 auto", marginBottom: "10px"}}><strong>Create New Violation Version: <span style={{color: "#006C94"}}>{violation.arsCode}</span></strong></label>
                                <p style={{color: "red", fontSize: "12px", margin: "0 auto", marginTop: "-12px", marginBottom: "2px"}}><strong>Note: </strong>Once Effective Start Date is changed a new violation version 
                                    will be created and an end date will be set to current version.</p>
                                <div className="form-row ">
                                    <label htmlFor="arsCode">ARS Code:</label>
                                    <input disabled id="arsCode" className="form-input-bold" type="text" title="ARS Code" value={updateViolation.arsCode} placeholder="ARS-Code"
                                        style={{cursor: "not-allowed", backgroundColor: "#ececec", color: "#000000",}}/>
                                </div>
            
                                <div className="form-row">
                                    <label htmlFor="fine">Fine:</label>
                                    <input id="fine" type="number" title="Fine" value={updateViolation.fine} placeholder="Fine" min="0" onChange={(e) =>
                                        setUpdateViolation({ ...updateViolation, fine: parseFloat(e.target.value) })} onWheel={(e) => e.target.blur()} onFocus={(e) => e.target.select()} required/>
                                </div>
            
                                <div className="form-row">
                                    <label htmlFor="effectiveStartDate">Effective Start Date:</label>
                                    <input id="effectiveStartDate" type="date" title="Effective Start Date" value={formattedDate2} required
                                        onChange={(e) => { 
                                            const date = e.target.value;
                                            setUpdateViolation({ ...updateViolation, effectiveStartDate: backToTimestamp(date) });}}/>
                                </div>
                                    <div className="rich-text-editor-edit-violation">
                                    {updateViolation.reduce != null ? (
                                        <div>
                                            <div className="form-row">
                                                <label htmlFor="reduce">Reduce To Amount: </label>
                                                <input id="reduce" title="Reduce To Amount" type="number" style={{ marginBottom: "8px" }} value={updateViolation.reduce} required min="0"
                                                    onWheel={(e) => e.target.blur()} onFocus={(e) => e.target.select()} onChange={(e) => {
                                                    setUpdateViolation({ ...updateViolation, reduce: (Number(e.target.value)) })}}/>
                                            </div>
                                            <div className="reduceFineNo">
                                                <label htmlFor="removeReduce" title="Remove Reduce Amount" className="remove-reduce-label" style={{cursor: "pointer"}}><span style={{textDecoration: "underline"}}>Remove Reduce Amount:</span> <span style={{fontWeight: "bold"}}>(This will <span style={{ color: "red"}}
                                                    >delete</span> the acceptable proof)</span>
                                                    <input type="checkbox" id="removeReduce" onChange={(e) => {if (e.target.checked) {
                                                        setUpdateViolation({ ...updateViolation, reduce: null, acceptableProof: getBlankRichText() });
                                                        setValue(getBlankRichText());
                                                    }}} />
                                                </label>
                                            </div>    
                                        </div>
                                    ) : (
                                    <div className="reduceFineYes">
                                        <label id="needReduceLabel" title="Reduce fine amount?" style={{cursor: "pointer", textDecoration: "underline"}}>Need to reduce fine amount?
                                        <input type="checkbox" id="needReduce" checked={false} onChange={(e) => {if (e.target.checked) {
                                            setUpdateViolation({ ...updateViolation, reduce: 0})}}}/>
                                        </label>
                                    </div>
                                )}
                                        <div style={{width: "100%", marginTop: "10px", marginBottom: "10px"}}>
                                            <RichTextEditor key={`${updateViolation.id}-${updateViolation.reduce != null ? "reduce" : "info"}`} editor={editor} editor2={editor2} value={value} 
                                                value2={value2} onChange={(value) => setValue(value)} onChange2={(value2) => setValue2(value2)} headerText={false} showFirst={updateViolation.reduce != null}/>
                                        </div>    
                                    </div>
                                    <div className="controls-container">
                                        <Link to={`/dashboard/history/${violation.originalDocID}`} state={{ violation }} style={{fontSize: "14px"}} className="view-history-link" title="Show History">Show History</Link>
                                        <div className="buttons-container">
                                            <button className="save-edit-button" title="Save Edit" type="submit">Save Edit</button>
                                            {userRole === "admin" && (<button className="delete-violation-button" title="Delete Entire Violation" type="button" 
                                                onClick={handleDelete}>Delete Violation</button>)}
                                            <button className="cancel-edit-button" title="Cancel Edit" type="button" onClick={() => setUpdateViolation(null)}>Cancel</button>
                                        </div>
                                    </div>
                                    {/*<div style={{ flexBasis: '100%', height: 0 }}></div>*/}
                                    
                            </form>
                        </div>
                        
                    </div>
                    
                ) : (
                    <div className="violation-card-admin">
                        <h2>{violation.arsCode} 
                            <>      
                                <MdModeEdit onClick={() => startEditViolation(violation)} title={`Edit Violation: ${violation.arsCode}`}
                                    style={{ marginLeft: "10px", marginBottom: "-2px" }} /> 
                                <div className="vertical-line"></div> 
                                <MdUpdate onClick={() => startUpdateViolation(violation)} style={{ marginLeft: "10px", marginBottom: "-2px" }} 
                                    title={`Update to new version: ${violation.arsCode}`} /> 
                            </> 
                        </h2>
                        {/^\d+$/.test(violation.fine) ? ( <p>Fine: <strong style={{fontSize: "17px"}}>${violation.fine}</strong></p>
                            ) : (<p>Fine: <strong>{violation.fine}</strong></p>)}
                        <p>Start Date: <i>{violation.effectiveStartDate.toDate().toLocaleDateString()}</i></p>
                        {(violation.reduce != null || hasText(violation.additionalInfo)) ? (
                            <div style={{borderRadius: "5px", marginTop: "5px"}}>
                                <hr style={{backgroundColor: 'rgb(172, 172, 172)'}}/>
                                {violation.reduce != null ? (
                                    <>
                                        <p style={{fontFamily: "sans-serif", fontSize: "17px"}}>Reduce to: <strong style={{color: "#259b24"}}>
                                            ${violation.reduce}</strong></p>
                                        <p style={{textDecoration: "underline"}}>Defendant's Acceptable Proof (If Applicable):</p>
                                        <div style={{paddingLeft: "10px", fontSize: "16px",  fontFamily: "sans-serif"}}>{renderRichText(violation.acceptableProof)}</div>
                                    </>
                                ) : null}
                                {hasText(violation.additionalInfo) ? (
                                    <>
                                        <p style={{textDecoration: "underline"}}>Additional Information for Defendant:</p>
                                        <div style={{paddingLeft: "10px", fontSize: "16px", fontFamily: "sans-serif"}}>{renderRichText(violation.additionalInfo)}</div>
                                    </>
                                ) : null} 
                            </div> 
                        ) : null} 
                    </div>                               
                )} 
            </div>
        ))}
        </>
    )
}
